import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum } from '../../enums'

import { Highlights } from '../../views'

import { ROUTER_CONSTS } from '../router.consts'

export const HIGHLIGHTS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.HIGHLIGHTS],
    path: 'highlights',
    component: Highlights,
    meta: {
      featureId: FeatureIdEnum.HIGHLIGHTS,
    },
  },
]
